module.exports = __webpack_public_path__ + "static/revival2-5ab7dccca84e27e5e37bfb51ba675d1b.jpg";